import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Menu } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import UiMeet3dNav from "~/modules/UiMeet3d/constants/UiMeet3dNav";
import "~/applications/panel/styles/TourMenu.less";

const UiMeet3dMenu = observer(({ active, t }) => (
  <Menu pointing secondary vertical fluid>
    <div className="tour-layout-menu-container">
      <Menu.Item icon="home" as={Link} to="/ui-meet-3d" content={t("home")} active={active === UiMeet3dNav.HOME} />
      <Menu.Item
        icon="flag"
        as={Link}
        to="/ui-meet-3d/general"
        content={t("general")}
        active={active === UiMeet3dNav.GENERAL}
      />
      <Menu.Item
        icon="user circle"
        as={Link}
        to="/ui-meet-3d/greeting-bot"
        content={t("clientPanelMisc:greetingBot")}
        active={active === UiMeet3dNav.GREETING_BOT}
      />
      <Menu.Item
        icon="mail"
        as={Link}
        to="/ui-meet-3d/notifications"
        content={t("clientPanelMisc:notifications")}
        active={active === UiMeet3dNav.NOTIFICATIONS}
      />
      <Menu.Item
        icon="bullhorn"
        as={Link}
        to="/ui-meet-3d/events"
        content={t("clientPanelMisc:events")}
        active={active === UiMeet3dNav.EVENTS}
      />
      <Menu.Item
        icon="bullseye"
        as={Link}
        to="/ui-meet-3d/leads"
        content={t("clientPanelMisc:leads")}
        active={active === UiMeet3dNav.LEADS}
      />
      <Menu.Item
        icon="users"
        as={Link}
        to="/ui-meet-3d/meetings"
        content={t("clientPanelMisc:meetings")}
        active={active === UiMeet3dNav.COMPLETED_MEETINGS}
      />
    </div>
  </Menu>
));

UiMeet3dMenu.propTypes = {
  t: PropTypes.func.isRequired,
  active: PropTypes.oneOf([
    UiMeet3dNav.HOME,
    UiMeet3dNav.GENERAL,
    UiMeet3dNav.GREETING_BOT,
    UiMeet3dNav.NOTIFICATIONS,
    UiMeet3dNav.EVENTS,
    UiMeet3dNav.LEADS,
    UiMeet3dNav.COMPLETED_MEETINGS,
  ]),
};

export default withTranslation()(UiMeet3dMenu);
